import { render, staticRenderFns } from "./openShopOrderList.vue?vue&type=template&id=6cb595f1&scoped=true"
import script from "./openShopOrderList.vue?vue&type=script&lang=ts"
export * from "./openShopOrderList.vue?vue&type=script&lang=ts"
import style0 from "./openShopOrderList.vue?vue&type=style&index=0&id=6cb595f1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb595f1",
  null
  
)

export default component.exports